import { Divider } from "@mui/material";

import type { BaseLayoutElementDefinition } from "../layout-element";

export const FORM_SECTION_DIVIDER_LAYOUT_ELEMENT_TYPE = "form-section-divider";

export type FormSectionDividerLayoutElementDefinition =
  BaseLayoutElementDefinition & {
    type: typeof FORM_SECTION_DIVIDER_LAYOUT_ELEMENT_TYPE;
  };

export function FormSectionDividerLayoutElement() {
  return <Divider sx={{ my: 2, color: "primary.main" }} />;
}
